import React from "react";
import { Grid, List, Typography } from "@material-ui/core";
import ProcedureDefinitionItem from "./ReportDefinitionItem";
import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";
import ReportDefinitionItem from "./ReportDefinitionItem";

const ReportDefinitionsList = ({
  procedureDefinitions,
  onClickEditItem,
  onClickDeleteItem,
}: {
  procedureDefinitions: ReportExecutionOrder[];
  onClickEditItem: (procedureDefinition: ReportExecutionOrder) => void;
  onClickDeleteItem: (procedureDefinition: ReportExecutionOrder) => void;
}) => {
  return (
    <Grid container direction="row" justifyContent="center">
      <Grid item container justifyContent="center" xs={12}>
        <Grid item>
          <Typography variant="h6">
            List of Picked Report Definitions
          </Typography>
        </Grid>
      </Grid>

      <Grid item container justifyContent="center" xs={12}>
        <Grid item>
          {procedureDefinitions && procedureDefinitions.length !== 0 ? (
            <List>
              {procedureDefinitions
                .sort(
                  (
                    firstItem: ReportExecutionOrder,
                    secondItem: ReportExecutionOrder
                  ) => {
                    if (firstItem && secondItem) {
                      // return (
                      //   firstItem.execution_group_number -
                      //   secondItem.execution_group_number
                      // );
                    }

                    return 0;
                  }
                )
                .map((procedureDefinition) => (
                  <ReportDefinitionItem
                    procedureDefinitionItem={procedureDefinition}
                    onClickEditItem={(procedureDefinitionItem) => {
                      onClickEditItem(procedureDefinitionItem);
                    }}
                    onClickDeleteItem={(procedureDefinitionItem) => {
                      onClickDeleteItem(procedureDefinitionItem);
                    }}
                  />
                ))}
            </List>
          ) : (
            <p>No Picked report Definitions yet!</p>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportDefinitionsList;
